/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

const ReceiveStatus = {
  edit: {
    name: 'แก้ไขข้อมูล',
    color: 'warning',
    icon: 'border_color',
  },
  waiting: {
    name: 'รอรับเข้า',
    color: 'info',
    icon: 'task_alt',
  },
  reject: {
    name: 'ปฏิเสธรับเข้า',
    color: 'error',
    icon: 'highlight_off_outlined',
  },
  success: {
    name: 'รับสินค้า',
    color: 'success',
    icon: 'task_alt',
  },
  fixedcost: {
    name: 'ปันทุน',
    color: 'info',
    icon: 'task_alt',
  },
  approve: {
    name: 'อนุมัติ',
    color: 'success',
    icon: 'task_alt',
  },
  paid: {
    name: 'ชำระเงิน',
    color: 'success',
    icon: 'task_alt',
  },
  cancel: {
    name: 'ยกเลิก',
    color: 'error',
    icon: 'cancel',
  },
};

export default ReceiveStatus;
